<template>
    <auction-dialog title="설치 및 보관 안내" @open="init">
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template #default>
            <div>
                <h4 class="font-size-16 font-size-18 mb-2 mb-md-4">설치</h4>
                <p class="font-size-14 line-height-16 primary--text">당사 낙찰 작품에 한하여 배송 시 설치를 함께 요청하실 수 있으며, 사전 예약이 필요합니다.</p>
                <div class="mt-8 mt-md-12">
                    <v-card tile elevation="0" class="grey-ef">
                        <v-card-text class="pa-16 pa-md-24">
                            <ul class="dot-list">
                                <li>80호 미만은 점당 3만원(추가 점당 1만원), 80호 이상은 점당 10만원(추가 점당 2만원)의 비용이 발생합니다.</li>
                                <li>대리석, 콘크리트, 가벽, 레일 등 현장 난이도에 따라 비용이 추가될 수 있습니다.</li>
                                <li>예약 없이 요청하시는 경우, 배송일정에 따라 바로 설치를 해드리기 어려울 수 있습니다.</li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </div>
            </div>

            <div class="mt-14 mt-md-18">
                <h4 class="font-size-16 font-size-18 mb-2 mb-md-4">보관</h4>
                <p class="font-size-14 line-height-16 primary--text">낙찰 및 판매 이후 7일 경과 시 입금여부와 무관하게 일 30,000원/점의 비용이 발생합니다.</p>
            </div>
        </template>
    </auction-dialog>
</template>

<script>
import AuctionDialog from "./auction-dialog.vue";

export default {
    components: { AuctionDialog },
    methods: {
        async init() {
            //
        },
    },
};
</script>

<style></style>
